import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FileText, Loader2, X } from "lucide-react";
import { api } from "@/lib/api";
import CguContent from "@/components/price/CguContent";

// Lecture seule de la version des CGU en vigueur (Réglages, inscription).
export default function CguViewerDialog({ onClose, withAcceptance = false }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    const req = withAcceptance ? api.get("/cgu/me") : api.get("/cgu/current").then((r) => ({ data: { current: r.data.version } }));
    req.then(({ data: d }) => setData(d)).catch(() => setData({ current: null }));
  }, [withAcceptance]);
  const v = data?.current;
  const acc = data?.last_acceptance;

  return createPortal(
    <div className="fixed inset-0 z-[96] flex items-end justify-center bg-black/60 sm:items-center sm:p-4" data-testid="cgu-viewer-dialog">
      <div className="flex max-h-[92vh] w-full max-w-2xl flex-col rounded-t-3xl bg-[#FFF8F1] street-border sm:rounded-3xl animate-in slide-in-from-bottom-4 duration-200">
        <div className="flex items-center justify-between gap-3 border-b-2 border-foreground/10 p-4">
          <div className="flex items-center gap-2 font-[Outfit] text-[17px] font-black"><FileText className="h-5 w-5" />Conditions Générales d&apos;Utilisation</div>
          <button type="button" onClick={onClose} aria-label="Fermer" className="grid h-9 w-9 place-items-center rounded-full bg-white street-border-thin" data-testid="cgu-viewer-close"><X className="h-4 w-4" /></button>
        </div>
        <div className="overflow-y-auto px-5 pb-6 pt-3">
          {!data && <Loader2 className="mx-auto my-10 h-6 w-6 animate-spin" />}
          {data && !v && (
            <p className="my-6 text-sm font-semibold" data-testid="cgu-viewer-static">
              Les CGU en vigueur sont consultables sur <a className="font-black text-primary underline" href="/cgu" target="_blank" rel="noreferrer">pricecovoit.fr/cgu</a>.
            </p>
          )}
          {v && (
            <>
              <div className="mt-1 text-[12px] font-bold text-foreground/60" data-testid="cgu-viewer-version">
                Version {v.version} · en vigueur depuis le {new Date(v.published_at).toLocaleDateString("fr-FR")}
              </div>
              {withAcceptance && (
                <div className="mt-2 rounded-xl bg-white px-3 py-2 text-[12px] font-bold street-border-thin" data-testid="cgu-viewer-acceptance">
                  {acc ? `Tu as accepté la version ${acc.version} le ${new Date(acc.accepted_at).toLocaleString("fr-FR")}.` : "Aucune acceptation enregistrée pour ce compte."}
                </div>
              )}
              <CguContent content={v.content} testid="cgu-viewer-content" />
            </>
          )}
        </div>
      </div>
    </div>,
    document.body,
  );
}
